import React from "react";
import Home from "./Home";
import Cuisine from "./Cuisine";
import Searched from "./Searched";
import Recipe from "./Recipe";
import Favourite from "./Favourite";
import { Route, Routes } from "react-router-dom";
import AddRecipe from "./AddRecipe";

function Pages({ onSearch }) {
  return (
     <Routes>
        <Route path="/" element={<Home onSearch={onSearch} />} />
        <Route path="/cuisine/:type" element={<Cuisine />} />
        <Route path="/searched/:search" element={<Searched />} />
        <Route path="/recipe/:name" element={<Recipe />} />
        <Route path="/Favourite" element={<Favourite />} />
        <Route path="/newrecipe" element={<AddRecipe />} />
      </Routes>
  );

} 
export default Pages
